import { Action as UserAction } from '../actions/user';
import { Action as VehiclesAction } from '../actions/vehicles';
import { Action as ContestAction } from '../actions/contests';

const defaultState = {
  name: undefined,
  isFetching: false,
  isCountingFavoriteStations: false,
  isCountingUserVehicles: false,
  isUploadingImage: false,
  imageUploadSuccess: undefined,
  isEnteringContest: false,
  submissionSuccessful: false,
  isSavingAddress: false,
  byName: {},
  address: {},
  tags: {},
  error: undefined,
  isUpdatingMembername: false,
  membernameUpdateError: undefined,
};

export default function userReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action?.type) {
    case UserAction.MemberInfo.MemberInfoPending:
    case UserAction.MemberInfo.MemberContestInfoPending:
      return {
        ...state,
        isFetching: true,
        error: undefined,
      };

    case UserAction.MemberInfo.MemberInfoCompleted:
      return {
        ...state,
        ...body.member,
        isFetching: false,
        byName: {
          ...state.byName,
          [body.member.name]: body.member,
        },
      };

    case UserAction.MemberInfo.MemberInfoFailed:
      return {
        ...state,
        isFetching: false,
        error: 'There was an error retrieving your profile',
      };

    case UserAction.Membername.UpdatePending: {
      return {
        ...state,
        isUpdatingMembername: true,
        membernameUpdateError: undefined,
      };
    }

    case UserAction.Membername.UpdateCompleted: {
      return {
        ...state,
        ...body.member,
        isUpdatingMembername: false,
        byName: {
          [body.member.name]: body.member,
        },
      };
    }

    case UserAction.Membername.UpdateFailed: {
      return {
        ...state,
        isUpdatingMembername: false,
        membernameUpdateError: body.status === 409 ? 'Username taken' : 'There was a problem updating your username',
      };
    }

    case UserAction.Membername.UpdateReset: {
      return {
        ...state,
        isUpdatingMembername: false,
        membernameUpdateError: undefined,
      };
    }

    case UserAction.Membername.UpdateFinished: {
      return {
        ...state,
        tags: {
          ...state.tags,
          generatedMembername: false,
        },
      };
    }

    case UserAction.MemberInfo.MemberContestInfoCompleted:
      return {
        ...state,
        isFetching: false,
        contestProfile: body.member,
      };

    case UserAction.MemberInfo.MemberUploadImagePending:
      return {
        ...state,
        isUploadingImage: true,
      };

    case UserAction.MemberInfo.MemberUploadImageFailed:
      return {
        ...state,
        isUploadingImage: false,
        imageUploadSuccess: false,
      };

    case UserAction.MemberInfo.MemberUploadImageCompleted:
      return {
        ...state,
        isUploadingImage: false,
        imageUploadSuccess: !!body.success,
      };

    case ContestAction.Contests.EnterContestPending:
      return {
        ...state,
        isEnteringContest: true,
        submissionSuccessful: false,
        error: undefined,
      };

    case ContestAction.Contests.EnterContestCompleted:
      return {
        ...state,
        isEnteringContest: false,
        error: undefined,
        submissionSuccessful: true,
      };

    case ContestAction.Contests.EnterContestFailed:
      return {
        ...state,
        isEnteringContest: false,
        error: body.error?.message || 'There was an error submitting your entries.',
        submissionSuccessful: false,
      };

    case UserAction.Address.UpdateAddressPending:
      return {
        ...state,
        isSavingAddress: true,
        error: '',
      };

    case UserAction.Address.UpdateAddressCompleted:
      return {
        ...state,
        error: (body.error && body.error.message) || undefined,
        isSavingAddress: false,
        address: body.error ? state.address : body.address,
      };

    case VehiclesAction.MemberInfo.VehicleCountPending:
      return {
        ...state,
        isCountingUserVehicles: true,
        error: undefined,
      };

    case VehiclesAction.MemberInfo.VehicleCountCompleted:
      return {
        ...state,
        isCountingUserVehicles: false,
        byName: {
          ...state.byName,
          [body.memberName]: {
            ...state.byName[body.memberName],
            vehicleProfilesCount: body.count,
          },
        },
      };

    case VehiclesAction.MemberInfo.VehicleCountFailed:
      return {
        ...state,
        isCountingUserVehicles: false,
        error: 'There was an error getting count of your vehicle profiles',
      };

    default:
      return state;
  }
}
